module.exports = __webpack_public_path__ + "static/media/dang-gui.4fe9f20b.jpg";